import React, {useEffect, useState} from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withLayout from "../../../components/desktop/layout/component";
import style from "./style.css";
import { DEFAULT_FAQS } from "../../../utils/appointment-confirmation-faq/selector";
import ConfirmationDocumentsFaq from "../../../components/desktop/confirmation-documents-faq";
const Documents = () => {
    const [isOpenCategories, setIsOpenCategories] = useState([]);
    const [faqs, setFaqs] = useState(null);
    useEffect(() => {
        const faqsOpen = [];
        const fetchedFaq = DEFAULT_FAQS;
        fetchedFaq.map((item) => {
            let firstOpen = true;
            if (item.id > 1) {
                firstOpen = false;
            }
            const data = {isOpen: firstOpen, list: []};
            item.option.map((opt, k) => {
                let optOpen = false;
                if (opt.id > 1) {
                    optOpen = false;
                }
                if (opt.subOption && opt.subOption.length && opt.id === 1) {
                    optOpen = true;
                }
                const list = {isOpen: optOpen, listItem: []};
                data.list.push(list);
                if (opt.subOption &&  opt.subOption.length) {
                    // eslint-disable-next-line max-nested-callbacks
                    opt.subOption.map((innerOpt) => {
                        let innerOpen = false;
                        if (innerOpt.id > 1) {
                            innerOpen = false;
                        }
                        const listItem = {isOpen: innerOpen};
                        data.list[k].listItem.push(listItem);
                    });
                }
            });
            faqsOpen.push(data);
        });
        setIsOpenCategories(faqsOpen);
        setFaqs(fetchedFaq);
    }, []);
    return (
        <React.Fragment>
            <Helmet>
                <title>
                Cars24 | Required Documents
                </title>
                <link href={`${appUrl()}/documents/`} rel="canonical" />
            </Helmet>
            <ErrorHandler>
                <div className={"container"}>
                    <h1 styleName={"style.heading"}>
                Please keep your documents ready before inspection.
                    </h1>
                    <div styleName={"style.content"}>
                        <ConfirmationDocumentsFaq faqs={faqs} isOpenCategories={isOpenCategories} setIsOpenCategories={setIsOpenCategories}/>
                    </div>
                </div>
            </ErrorHandler>
        </React.Fragment>
    );
};
export default withLayout(Documents);
